import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        flexFlow: "row-wrap",
        border: '1px solid  #cccccc ',
        borderRadius: '20px',                
        position: "relative",
        width: "100%",
        overflow: "auto",
        paddingLeft: '0px',
        paddingRight: '0px',
    },

    root: {
        paddingLeft: '100px',
        paddingRight: '100px',        
        // paddingLeft: '30px',
        // paddingRight: '30px',
    },

    marginBoton:{
        paddingBottom: '10px',
    },

    marginText:{
        paddingLeft: '10px',
        display: 'initial'
    },

    rootLista: {
        width: '100%',
        maxWidth: '100%',
    },

    rootListItem: {
        paddingBottom: '4px',
        paddingTop: '0px',
    },
    colorIcon:{
        color: 'black',
    },

    colorChip:{
        backgroundColor: '#1C4E78',
        color:'white'
    },
    AlignTable:{     
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },    
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
	image: {
		width: 70,
		height: 70,
	},
	img: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
	},     
    h1:{
        textAlign: 'center',
        color: '#000',
        // fontFamily: 'none',
        margin: 0,
       '@media (max-width:2000px)':{ // web
            fontSize: '1rem',
        },
       '@media (max-width:1000px)':{ // web
            fontSize: '1rem',
        },
       '@media (max-width:768px)':{ //ipad
            fontSize: '1rem',
        },
       '@media (max-width:415px)':{ //mobile
            fontSize: '1rem',
            marginRight: '10%',
        }
    },   
	input: {
		display: 'none',
	},     
	label: {
		width: "80%",
		display: "flex",
		justifyContent: "center",
		alignItems: 'center'
	  },
	imageUpload: {
		background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        border: 0,
		borderRadius: 3,
		boxShadow:'0 3px 5px 2px rgba(119, 241, 255)',
		color: 'white',
        height: 37,
		padding: '5px 30px',
        margin: theme.spacing(1),
		textAlign: "center",
		// textTransform: 'uppercase',
		cursor: "pointer",
		// width: "200px",
		fontSize: '16px',
	  },
      title: {
        width: '100%',
        fontSize: "1.8rem",
        fontWeight: 600,
        textAlign: 'center',
        color: '#595959',
        marginTop: 30,
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: {
          fontSize: 22,
        },
      },
      description: {
        width: '100%',
        fontWeight: 600,
        fontSize: '1.125rem',
        lineHeight: '27px',
        color: '#545454',
        textAlign: 'center',
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: {
          fontSize: 18,
        },
      },      
}))